import React, { useState, useEffect } from 'react'
import { useTheme } from 'styled-components'

import { Swiper, SwiperSlide } from 'swiper/react'
import { Navigation, Autoplay } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/navigation'
import { useEvent } from '~components'
import {
  BannerContainer,
  SlideWrapper,
  TextSection,
  BannerHeaderSection
} from './styles'

import { HomeBanner as HomeBannerController } from './HomeBanner'
// import { auto } from '@popperjs/core'

const HomeBannerUI = (props) => {
  const {
    homePageBanner
  } = props
  console.log(homePageBanner)
  const theme = useTheme()
  console.log(theme)
  const [events] = useEvent()
  const handleGoToBusinessPage = (item) => {
    events.emit('go_to_page', { page: 'business', params: { business_slug: item.bus_slug } })
  }

  const [defaultSlidesPerView, setDefaultSlidesPerView] = useState(4)

  useEffect(() => {
    const updateSlidesPerView = () => {
      const width = window.innerWidth
      if (width >= 1024) {
        setDefaultSlidesPerView(4)
      } else if (width >= 768) {
        setDefaultSlidesPerView(3)
      } else if (width >= 480) {
        setDefaultSlidesPerView(2)
      } else {
        setDefaultSlidesPerView(1)
      }
    }

    updateSlidesPerView() // Initial call
    window.addEventListener('resize', updateSlidesPerView) // Update on resize

    return () => {
      window.removeEventListener('resize', updateSlidesPerView) // Cleanup
    }
  }, [])

  return (
    <>
      {homePageBanner?.length > 0 && (
        <BannerContainer>
          <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            padding: '25px 0px 16px 0px'
          }}>
            <BannerHeaderSection>

              <p>Thanksgiving favorites</p>

              <span>Shop now</span>

            </BannerHeaderSection>
          </div>
          <div>

          </div>
          <Swiper
            navigation={{
              enabled: true
            }}
            spaceBetween={10} // Space between slides
            modules={[Navigation, Autoplay]}
            autoplay={{
              delay: 5000, // Auto-slide every 5 seconds
              disableOnInteraction: false
            }}
            style={{
              width: '95%',
              padding: '25px 0px 15px 0px'
            }}
            shortSwipes={false}
            loop={homePageBanner.length > defaultSlidesPerView}
            slidesPerView={defaultSlidesPerView} // Show 4 slides at a time
            breakpoints={{
              1024: {
                slidesPerView: 4, // 4 slides for desktop
                spaceBetween: 10
              },
              768: {
                slidesPerView: 3, // 3 slides for tablet
                spaceBetween: 15
              },
              480: {
                slidesPerView: 2, // 2 slides for smaller devices
                spaceBetween: 10
              },
              320: {
                slidesPerView: 1, // 1 slide for small mobile screens
                spaceBetween: 5
              }
            }}
          >

            {homePageBanner?.map((item, i) => (
              <SwiperSlide key={i}>
                <SlideWrapper>

                  <img
                    style={{
                      borderTopLeftRadius: 10,
                      borderBottomLeftRadius: 10,
                      width: '55%'
                    }}
                    src={item.image} alt='' />

                  <TextSection >
                    <h2>{item.name}</h2>
                    <p>{item.description}</p>
                    <div
                      onClick={() => handleGoToBusinessPage(item)}
                      style={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        margin: 0,
                        padding: 0,
                        cursor: 'pointer'
                      }}
                    >
                      <div
                        style={{
                          fontSize: 12,
                          color: '#220A0A',
                          fontWeight: '500'
                        }}
                      >
                        Order Now
                      </div>
                      <svg
                        style={{
                          color: '#220A0A',
                          fontWeight: '500'
                        }}
                        xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" className="bi bi-chevron-right" viewBox="0 0 16 16">
                        <path fillRule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708" />
                      </svg>
                    </div>

                  </TextSection>
                </SlideWrapper>
              </SwiperSlide>
            ))}
          </Swiper>
        </BannerContainer>
      )}
    </>
  )
}

export const HomeBanner = (props) => {
  const homebannerProps = {
    ...props,
    UIComponent: HomeBannerUI
  }

  return (
    <HomeBannerController {...homebannerProps} />
  )
}
